module.exports = __webpack_public_path__ + "img/ck_on.b4ce5f00.svg";